module.exports = __webpack_public_path__ + "static/media/boy-3.cb789377.svg";